function sortNext()
{

CFPTendOrderItems = [$("#item_1").index(),$("#item_2").index(),$("#item_3").index(),$("#item_4").index(),$("#item_5").index(),$("#item_6").index()];
CFPTerror = 0;
for (var iStim = 0; iStim < 6; iStim++) {CFPTendOrderStim[CFPTendOrderItems[iStim]] = CFPTcorrectOrder[CFPTstartOrderStim[CFPTstartOrderItems[iStim]]];}
for (var iStim = 0; iStim < 6; iStim++) {CFPTerror = CFPTerror + Math.abs(CFPTcorrectOrder.indexOf(CFPTdisplayOrder[iStim])-CFPTendOrderStim.indexOf(CFPTdisplayOrder[iStim]));}
if(listArrays[allColumns.indexOf('stim6')][trialRow]!="na"){resetSort();} //restore original order; needed for whatever reason to compute the error correctly

finalOrder = CFPTendOrderStim.toString();
finalOrder = finalOrder.replace(/,/g,';');

document.getElementById("timer").style.color = "#000000"; //return timer to black
$('#sortImg').empty();//new CFPT sortable

}